import React, {useEffect, useContext} from "react";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon"
import exportSmallTokens from "@amzn/meridian-tokens/base/icon/export-small"
import Table, {
    TableRow,
    TableCell,
    TableSectionHeader,
} from "@amzn/meridian/table";
import {LineHaulListContext} from "./context/LineHaulListContext";
import {getTime, getRegion, getRefereshInterval} from "../util/Util";
import {FormattedMessage} from "react-intl";
import {ReceiveGroupByContext} from "../receive/context/ReceiveGroupByContext";

const LineHauls = (props) => {
    const {viewModel, dispatch} = useContext(LineHaulListContext);
    const { groups } = useContext(ReceiveGroupByContext);

    const onLineHaulClick = (lineHaul) => {
        let origin = lineHaul.origin ? lineHaul.origin : "-";
        const url = "/linehaulDetail/" + lineHaul.lineHaulId + "/" + origin + "/" +
            (lineHaul.lineHaulTime.actualTime ? lineHaul.lineHaulTime.actualTime : "-") + "/" +
            (lineHaul.lineHaulTime.departedTime ? lineHaul.lineHaulTime.departedTime : "-");
        props.history.push(url)
    }

    const getPackageListUrl = (lineHaul) => {
        return "#packageList/" + lineHaul.lineHaulId
    };

    const getLocationUrl = (lineHaul) => {
        let region = getRegion();
        switch(region) {
            case "US" :
                return "https://mmat-maps-iad.iad.proxy.amazon.com/asset-status-history?loadType=VRID&loadId=" + lineHaul.lineHaulId
            case "EU" :
                return "https://mmat-maps-dub.dub.proxy.amazon.com/asset-status-history?loadType=VRID&loadId=" + lineHaul.lineHaulId
            case "FE" :
                return "https://mmat-maps-pdx.pdx.proxy.amazon.com/asset-status-history?loadType=VRID&loadId=" + lineHaul.lineHaulId
            default :
                return "https://mmat-maps-iad.iad.proxy.amazon.com/asset-status-history?loadType=VRID&loadId=" + lineHaul.lineHaulId
        }
    }

    const getData = (selectedGroup) => {
        dispatch({type: 'LOAD_VIEW', data:{groupBy: selectedGroup, dispatcher: dispatch}});
    }

    const getFMCUrl = (lineHaul) => {
        let region = getRegion()
        switch(region) {
            case "US" :
                return "https://trans-logistics.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
            case "EU" :
                return "https://trans-logistics-eu.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
            case "FE" :
                return "https://trans-logistics-fe.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
            default :
                return "https://trans-logistics.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
        }
    }

    useEffect(() => {
        getData(groups.selectedGroup.value)
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData(groups.selectedGroup.value)
            }
        }, getRefereshInterval());
        return () => clearInterval(interval);
    }, [groups.selectedGroup.value]);

    return (
        <div>
            <Row widths={["grid-11"]} alignmentVertical="top" spacingInset="large">
                <div>
                    <Heading level ={2} type="h400" alignment="left">
                        <FormattedMessage id="linehaul.linehauls" defaultMessage="Linehauls"/>
                    </Heading>
                    <br/>
                    <Table headerRows={2} spacing="small">
                        <TableRow>
                            <TableCell alignmentHorizontal = "left">
                                <FormattedMessage id="linehaul.status" defaultMessage="Status"/>
                            </TableCell>
                            <TableCell />
                            <TableCell alignmentHorizontal = "center">
                                <FormattedMessage id="linehaul.arrival" defaultMessage="Arrival"/>
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell alignmentHorizontal = "center">
                                <FormattedMessage id="linehaul.details" defaultMessage="Details"/>
                            </TableCell>
                            <TableCell />
                            <TableCell />
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <FormattedMessage id="linehaul.vrid" defaultMessage="VRID"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="linehaul.origin" defaultMessage="Origin"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="linehaul.status" defaultMessage="Status"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="linehaul.location" defaultMessage="Location"/>
                            </TableCell>
                            <TableCell alignmentHorizontal = "right">
                                <FormattedMessage id="linehaul.planned" defaultMessage="Planned"/>
                            </TableCell>
                            <TableCell alignmentHorizontal = "right">
                                <FormattedMessage id="linehaul.actual" defaultMessage="Actual"/>
                            </TableCell>
                            <TableCell alignmentHorizontal = "center">
                                <FormattedMessage id="linehaul.volume" defaultMessage="volume"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="linehaul.FMC" defaultMessage="FMC"/>
                            </TableCell>
                        </TableRow>
                        { viewModel.arrived.length > 0 ?
                            <TableSectionHeader>
                                <FormattedMessage id="linehaul.arrived" defaultMessage="Arrived"/>
                            </TableSectionHeader>
                            : null }
                        {viewModel.arrived.map(lineHaul => (
                                <TableRow key={lineHaul.lineHaulId} highlightOnHover={true} onClick={() => {onLineHaulClick(lineHaul)}}>
                                    <TableCell>
                                        <Text type="h100">{lineHaul.lineHaulId}</Text>
                                    </TableCell>
                                    <TableCell>{lineHaul.origin}</TableCell>
                                    <TableCell>
                                        <FormattedMessage id="linehaul.inyard" defaultMessage="In Yard"/>
                                    </TableCell>
                                    <TableCell>
                                        {lineHaul.targetDockDoor !== null ? lineHaul.targetDockDoor : "-"}
                                    </TableCell>
                                    <TableCell alignmentHorizontal = "right">{getTime(lineHaul.lineHaulTime.plannedTime)}</TableCell>
                                    <TableCell alignmentHorizontal = "right">
                                        {(lineHaul.lineHaulTime.actualTime === null || lineHaul.lineHaulTime.actualTime === '') ?
                                            (lineHaul.lineHaulTime.gpsTime === null || lineHaul.lineHaulTime.gpsTime === '') ? ''
                                                : getTime(lineHaul.lineHaulTime.gpsTime)
                                            : getTime(lineHaul.lineHaulTime.actualTime)}
                                    </TableCell>
                                    <TableCell alignmentHorizontal = "center">
                                        {
                                            lineHaul.volume === 0 ? '-' :
                                                <Link href={getPackageListUrl(lineHaul)} type="secondary">{
                                                    lineHaul.groupedVolume ? lineHaul.groupedVolume : lineHaul.volume
                                                }</Link>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Link href = {getFMCUrl(lineHaul)} type="secondary" target="_blank" rel="noreferrer noopener">
                                            View <Icon tokens={exportSmallTokens} />
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                        { viewModel.inComing.length > 0 ?
                            <TableSectionHeader>
                                <FormattedMessage id="linehaul.incoming" defaultMessage="Incoming"/>
                            </TableSectionHeader>
                            : null }
                        {viewModel.inComing.map(lineHaul => (
                                <TableRow key={lineHaul.lineHaulId} highlightOnHover={true} onClick={() => {onLineHaulClick(lineHaul)}}>
                                    <TableCell>
                                        <Text type="h100">{lineHaul.lineHaulId}</Text>
                                    </TableCell>
                                    <TableCell>{lineHaul.origin ? lineHaul.origin : '-'}</TableCell>
                                    <TableCell>{lineHaul.lineHaulStatus}</TableCell>
                                    <TableCell>
                                        {lineHaul.targetDockDoor !== null ? lineHaul.targetDockDoor :
                                            <Link href={getLocationUrl(lineHaul)} type="secondary" target="_blank" rel="noreferrer noopener">
                                                View <Icon tokens={exportSmallTokens} />
                                            </Link>
                                        }
                                    </TableCell>
                                    <TableCell alignmentHorizontal = "right">
                                        {getTime(lineHaul.lineHaulTime.plannedTime)}
                                    </TableCell>
                                    <TableCell alignmentHorizontal = "right">
                                        {lineHaul.lineHaulTime.gpsTime === null ?
                                            (lineHaul.lineHaulTime.actualTime === null || lineHaul.lineHaulTime.actualTime === '') ? ''
                                                : ("Exp " + getTime(lineHaul.lineHaulTime.actualTime))
                                            : getTime(lineHaul.lineHaulTime.gpsTime)}
                                    </TableCell>
                                    <TableCell alignmentHorizontal = "center">
                                        {
                                            lineHaul.volume === 0 ? '-' :
                                                <Link href={getPackageListUrl(lineHaul)} type="secondary">{
                                                    lineHaul.groupedVolume ? lineHaul.groupedVolume : lineHaul.volume
                                                }</Link>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Link href={getFMCUrl(lineHaul)} type="secondary" target="_blank" rel="noreferrer noopener">
                                            View <Icon tokens={exportSmallTokens} />
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                    </Table>
                </div>
            </Row>
        </div>
    );
}

export default LineHauls


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHauls.js